module.exports = __webpack_public_path__ + "img/roadmap-cell-bg-3.39e83385.svg";